<template lang="pug">
  v-form
    //- v-overlay(absolute, v-if="loading")
    v-tabs(dark)
      v-tab(
        v-for="relation in [{name: entity.name}, ...relations]",
        :key="relation.name",
        :href="`#${relation.name}`"
        :class="{ red: Object.keys($formatErrors(errors, relation)).length }"
       ) {{ $pascalToHuman(relation.name) }}
      v-tab(
        key="Instance-History",
        href="#Instance-History",
        :disabled="editMode",
       ) Instance History
      v-dialog(v-if="editMode", v-model="showDialog")
        template(v-slot:activator="{ on }")
          v-btn(fab, icon, small, v-on="on")
            v-icon mdi-plus
        v-card
          v-card-title Set Rules
          v-card-text
            app-create-field(v-model="newTab", :items="$findEntity(entity.entity).fields.filter(x => !x.primitive)", :types="listEntities")
          v-card-actions
            v-spacer
            v-btn(outlined, @click="addTab") Save
      v-tab-item(
        key="Instance-History",
        value="Instance-History"
       )
        instance-history(:instance="instance")
      v-tab-item(:key="entity.name", :value="entity.name")
        app-entity-form(
          v-model="instance",
          :entity="entity",
          @update:entity="$emit('update:entity', $event)"
          :iinstance="instance",
          :errors="errors",
          v-bind="{ editMode }",
          )
      v-tab-item(
        v-for="relation in relations",
        :key="relation.name",
        :value="relation.name"
      )
        slot(
          :name="relation.name",
          :$$relation="relation",
          :$$entity="$findEntity(relation.type)",
          :$$errors="$formatErrors(errors, relation)",
          :$iinstance="instance[$lcfirst(relation.name)]",
          :$$options="{ foreigns: true }",
          :$$load="instance.id && { entity: instance, relation: relation.name }",
          :$$parent="instance"
        )
          component(
            :ignore="{relations:[]}",
            :finder="true"
            :autocomplate="true",
            :is="relation.multiple ? 'app-old-entity-list' : 'app-entity-form'"
            :entity="$findEntity(relation.type)",
            :errors="$formatErrors(errors, relation)",
            :iinstance="instance[$lcfirst(relation.name)]",
            :options="{ foreigns: true }",
            v-model="instance[relation.name]",
            :load="instance.id && { entity: instance, relation: relation.name }",
            :parent="instance"
          )
    //- pre {{ instance }}
</template>

<script>
import { EntityMixin } from '@@/components/mixins'
import InstanceHistory from '@@/components/InstanceHistory'
import { AppEntityForm, AppOldEntityList } from '@@/components/entities'

export default {
  components: {
    AppEntityForm,
    AppOldEntityList,
    InstanceHistory
  },

  props: {
    components: {
      type: Object,
      default: () => ({}) // { OrderLine: 'Orderline'  }
    },
    // TODO:
    entity: {
      type: Object,
      default: () => ({})
    },
    iinstance: {
      type: Object,
      default: () => ({})
    },
    ignore: {
      type: Array,
      default: () => ([])
    },
    tabs: {
      type: String,
      default: 'all'
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  name: 'entity-full-form',

  data () {
    return {
      disabled: false,
      showSingleRelationForms: false,
      instance: { ...this.iinstance },
      newTab: {},
      showDialog: false,
    }
  },

  watch: {
    instance: {
      deep: true,
      immediate: true,
      handler (instance) {
        this.$emit('input', instance)
      }
    },
  },

  computed: {
    relations () {
      return this.entity.fields.filter(f => !f.primitive && f.type !== 'User' && f.type !== 'ExtraData')
    },
    listEntities() {
      return this.$store.state.schema.map(x => x.name);
    },
  },
  methods: {
    addTab() {
      this.$emit('update:entity', {...this.entity, fields: [...this.entity.fields, { ...this.newTab, primitive: false }]});
      this.showDialog = false;
    },
    updateRelation(o, relation) {
      this.instance = { ...this.instance, [relation]: o }
    },

    /* TODO: docs */
    async save () {
      //
    }
  },
  async mounted () {
    //
  }
  /*
  [
    {
      field: "Volume",
      expression: "Heght * width * depth"
    },
    {
      field: "Volume",
      expression: "Heght * width * depth"
    },
  ]
  */
}
</script>
